import { render } from "./App.vue?vue&type=template&id=35e38345"
const script = {}

import "./App.vue?vue&type=style&index=0&id=35e38345&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__